// extracted by mini-css-extract-plugin
module.exports = {"roomHeader":"roomHeader--F1b1j","workplaces":"workplaces--224fR","wpActions":"wpActions--IJ6lN"};